import { useLoggedOutSuppliersPageMetaTags } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersPageMetaTags/__internal__/useLoggedOutSuppliersPageMetaTags";

export const useLoggedOutSuppliersPageMetaTagsTitleAndDescription = () => {
  const title = useLoggedOutSuppliersPageMetaTags().seoCategoryText?.title;
  const description =
    useLoggedOutSuppliersPageMetaTags().seoCategoryText?.meta_description;

  return { title, description };
};
